import React from 'react';
import PropTypes from 'prop-types';
import ContributionType from '@/constants/ContributionType';
import PaymentType from '@/constants/PaymentType';
import {
  DONATION_PAYMENT_METHODS,
  DONATION_TYPES,
} from '@/lib/configs/contributions';

const DONATION_TYPE = 'donation-type';
const PAYMENT_METHOD = 'payment-method';

export default function ContributionEnumIcon({ enumValue, type }) {
  let iconAlt;
  let icon;
  let text;
  if (type === PAYMENT_METHOD) {
    ({ iconAlt, icon, text } =
      DONATION_PAYMENT_METHODS.find(({ value }) => value === enumValue) || {});
  }
  if (type === DONATION_TYPE) {
    ({
      iconAlt,
      icon,
      displayText: text,
    } = DONATION_TYPES[enumValue.toUpperCase()] || {});
  }
  return (
    <>
      {icon && (
        <img
          className="mr-2 inline h-4 w-4"
          id={`${iconAlt}-img`}
          alt={`${iconAlt}-alt`}
          src={icon}
          data-testid={`donation-enum-icon-${enumValue}`}
        />
      )}
      {text}
    </>
  );
}

ContributionEnumIcon.propTypes = {
  enumValue: PropTypes.oneOf([
    ...Object.values(ContributionType),
    ...Object.values(PaymentType),
  ]).isRequired,
  type: PropTypes.oneOf([DONATION_TYPE, PAYMENT_METHOD]).isRequired,
};

ContributionEnumIcon.donationType = DONATION_TYPE;
ContributionEnumIcon.paymentMethod = PAYMENT_METHOD;
